var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"realTimeLoadBody",style:(_vm.backImg('/huapu/discountBox.png'))},[_c('vchart',{ref:"vchartLine",attrs:{"themes":"purple-passion"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }